// @ts-nocheck
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import get from 'lodash/get';
import find from 'lodash/find';
import classnames from 'classnames';
import { Button } from '@cancercentrum/rcc-bootstrap';
import withI18n from '../../i18n/hoc';
import { isBetweenDates } from '../../utils/date';
class ListButtonGroup extends PureComponent {
    static defaultProps = {
        formatter: (x)=>x.text,
        selectedBsStyle: 'info'
    };
    static inheritReviewerCheckboxWidth = true;
    getOptions = ()=>{
        const now = function() {
            const n = new Date();
            return new Date(n.getFullYear(), n.getMonth(), n.getDate());
        }();
        return (this.props.options || this.props.regvarMetadata.listValues).filter((item)=>item.id === this.props.value || isBetweenDates(now, item.validFrom, item.validTo) && item.text);
    };
    onChange = (item)=>{
        const val = get(item, 'id', null);
        this.props.onChange(val === this.props.value ? null : val);
    };
    onBlur = (blurEvent)=>{
        const nextFocusItemParent = get(blurEvent, 'relatedTarget.parentElement');
        if (nextFocusItemParent !== this.element && this.props.onBlur) {
            this.props.onBlur(blurEvent);
        }
    };
    render() {
        const { disabled, bsStyle, formatter, titleFormatter, selectedBsStyle, optionsCaption, readOnly, value, tabIndex, vertical, i18n } = this.props;
        const availableOptions = this.getOptions();
        const { t } = i18n;
        if (readOnly) {
            const item = value ? find(availableOptions, (x)=>x.id === value) : null;
            const captionText = optionsCaption || t('component.listbuttongroup.caption');
            const text = item ? formatter(item) : captionText;
            return /*#__PURE__*/ _jsx("div", {
                className: "form-control-plaintext",
                children: text
            });
        }
        const buttons = availableOptions.reduce((reduction, x)=>{
            const isSelected = value === x.id;
            // Lists for old designed forms usually have an 'empty' item.
            if (!x.value && !isSelected) {
                return reduction;
            }
            const title = titleFormatter ? titleFormatter(x) : '';
            reduction.push(/*#__PURE__*/ _jsx(Button, {
                bsStyle: isSelected ? selectedBsStyle : bsStyle,
                disabled: disabled || readOnly,
                className: classnames({
                    active: isSelected
                }),
                tabIndex: tabIndex,
                onClick: this.onChange.bind(this, x),
                onBlur: this.onBlur,
                title: title,
                children: formatter(x)
            }, x.id));
            return reduction;
        }, []);
        const btnGroupClass = classnames({
            'btn-group-vertical': vertical,
            'btn-group': !vertical
        }, 'list-button-group');
        return /*#__PURE__*/ _jsx("div", {
            ref: (e)=>this.element = e,
            className: btnGroupClass,
            role: "group",
            children: buttons
        });
    }
}
export default withI18n()(ListButtonGroup);
